import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createFomoCanonicalItems = (locale, now, { createOnlyImagePromotion, stateUiSetting, defaultDerivedTopSectionPromotionStart }) => [
    {
        id: 'registration_reward',
        promotion: createOnlyImagePromotion({
            id: 'registration_reward',
            title: Verbiage.fomo_registration_reward,
            url: '/promotion-page/registration_reward/',
            promotionUrl: '/promotion-page/registration_reward/',
            enabled: false,
            startDate: new Date('2025-10-17T00:00:00Z'),
            endDate: new Date('2026-12-31T23:59:59Z')
        }),
        surfaces: {},
        order: { promotions: 0 }
    },
    {
        id: 'limited_cashback',
        promotion: createOnlyImagePromotion({
            id: 'limited_cashback',
            title: Verbiage.fomo_limited_cashback,
            url: '/promotion-page/limited_cashback/',
            promotionUrl: '/promotion-page/limited_cashback/',
            startDate: new Date('2026-02-19T00:00:00Z'),
            endDate: new Date(stateUiSetting.promotions?.limitedCashbackExpired ?? 0),
            enabled: false
        }),
        surfaces: {
            bannerSwiper: {
                showTitle: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405'
            },
            bannerSwiperHome: {
                showTitle: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x1080'
            }
        },
        order: { promotions: 1, bannerSwiper: 3, bannerSwiperHome: 0 }
    },
    {
        id: 'deposit_bonus',
        promotion: createOnlyImagePromotion({
            id: 'deposit_bonus',
            title: Verbiage.fomo_deposit_bonus,
            url: '/promotion-page/deposit_bonus/',
            action: true,
            startDate: new Date('2025-02-26T00:00:00Z'),
            endDate: new Date('2026-07-15T23:59:59Z'),
            enabled: !(locale === 'ko' && now < (stateUiSetting.promotions?.limitedCashbackExpired ?? 0))
        }),
        surfaces: {
            bannerSwiper: {
                showTitle: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405'
            },
            bannerSwiperHome: {
                showTitle: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x1080'
            }
        },
        order: { promotions: 2, bannerSwiper: 4, bannerSwiperHome: 1 }
    },
    {
        id: 'jackpot',
        promotion: createOnlyImagePromotion({
            id: 'jackpot',
            title: Verbiage.jackpot,
            url: '/promotion-page/jackpot/',
            promotionUrl: '/casino',
            startDate: new Date('2025-02-26T00:00:00Z'),
            endDate: new Date('2026-07-15T23:59:59Z')
        }),
        surfaces: {
            bannerSwiper: {
                showTitle: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405'
            },
            bannerSwiperHome: {
                showTitle: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x1080'
            }
        },
        order: { promotions: 3, bannerSwiper: 5, bannerSwiperHome: 2 }
    },
    {
        id: 'ladder',
        surfaces: {
            bannerSwiper: {
                id: 'ladder',
                url: '/gametech/ladder/',
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405',
                showTitle: true,
                noSignUp: true,
                ext: 'svg'
            }
        },
        order: { bannerSwiper: 0 }
    },
    {
        id: 'updown',
        surfaces: {
            bannerSwiper: {
                id: 'updown',
                url: '/updown/updown/',
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405',
                showTitle: true,
                noSignUp: true,
                ext: 'svg'
            }
        },
        order: { bannerSwiper: 1 }
    },
    {
        id: 'livecasino',
        surfaces: {
            bannerSwiper: {
                id: 'livecasino',
                url: locale === 'ko'
                    ? '/evolution/korean_prosperity_tree_baccarat/'
                    : locale === 'ja'
                        ? '/evolution/japanese_speed_baccarat_a/'
                        : '/evolution/baccarat/',
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405',
                showTitle: true,
                noSignUp: true,
                ext: 'svg'
            }
        },
        order: { bannerSwiper: 2 }
    },
    {
        id: 'vip',
        surfaces: {
            bannerSwiper: {
                id: 'vip',
                url: '/vip/',
                showTitle: true,
                noSignUp: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405'
            },
            bannerSwiperHome: {
                id: 'vip',
                url: '/vip/',
                showTitle: true,
                noSignUp: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x1080'
            }
        },
        order: { bannerSwiper: 6, bannerSwiperHome: 3 }
    },
    {
        id: 'raf',
        surfaces: {
            bannerSwiper: {
                id: 'raf',
                url: '/referral/',
                showTitle: true,
                noSignUp: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x405'
            },
            bannerSwiperHome: {
                id: 'raf',
                url: '/referral/',
                showTitle: true,
                noSignUp: true,
                desktopBannerSize: '1400x350',
                mobileBannerSize: '1080x1080'
            }
        },
        order: { bannerSwiper: 7, bannerSwiperHome: 4 }
    },
    {
        id: 'fomoio-crash-and-win',
        promotion: {
            id: 'fomoio-crash-and-win',
            title: Verbiage.crash_and_win,
            description: Verbiage.fomoio_crash_and_win_description,
            buttonText: Verbiage.play_now,
            url: '/promotion-page/crash-&-win/',
            startDate: defaultDerivedTopSectionPromotionStart,
            banner: cfgToThemeCdnPath('/misc/cash-win.png'),
            enabled: false
        },
        topSection: {
            buttonVariant: 'primary'
        },
        order: { topSection: 0 }
    },
    {
        id: 'fomoio-races',
        promotion: {
            id: 'fomoio-races',
            title: Verbiage.fomoio_races,
            description: Verbiage.fomoio_races_description,
            buttonText: Verbiage.race_now,
            url: '/races/',
            startDate: defaultDerivedTopSectionPromotionStart,
            banner: cfgToThemeCdnPath('/misc/races.png'),
            enabled: false
        },
        topSection: {
            buttonVariant: 'primary',
            imageStyles: 'transform: scale(0.9);'
        },
        order: { topSection: 1 }
    },
    {
        id: 'fomoio-rakeboost',
        promotion: {
            id: 'fomoio-rakeboost',
            title: Verbiage.rakeboost,
            description: Verbiage.fomoio_rakeboost_description,
            buttonText: Verbiage.activate_now,
            url: '/vip/',
            startDate: defaultDerivedTopSectionPromotionStart,
            banner: cfgToThemeCdnPath('/misc/rakeboost.png'),
            enabled: false
        },
        topSection: {
            buttonVariant: 'secondary'
        },
        order: { topSection: 2 }
    },
    {
        id: 'fomoio-refer-and-earn',
        promotion: {
            id: 'fomoio-refer-and-earn',
            title: Verbiage.refer_and_earn,
            description: Verbiage.fomoio_refer_and_earn_description,
            buttonText: Verbiage.claim_now,
            url: '/referral/',
            startDate: defaultDerivedTopSectionPromotionStart,
            banner: cfgToThemeCdnPath('/misc/refer-earn.png'),
            enabled: false
        },
        topSection: {
            buttonVariant: 'secondary'
        },
        order: { topSection: 3 }
    },
    {
        id: 'fomoio-sportsbook',
        promotion: {
            id: 'fomoio-sportsbook',
            title: Verbiage.sportsbook,
            description: Verbiage.fomoio_sportsbook_description,
            buttonText: Verbiage.play_now,
            url: '/sports/',
            startDate: defaultDerivedTopSectionPromotionStart,
            banner: cfgToThemeCdnPath('/misc/sportsbook.png'),
            enabled: false
        },
        topSection: {
            buttonVariant: 'primary',
            imageStyles: 'transform: scale(0.85);',
            center: false,
            requiresSports: true
        },
        order: { topSection: 4 }
    },
    {
        id: 'fomoio-vip-club',
        promotion: {
            id: 'fomoio-vip-club',
            title: Verbiage.join_the_vip_club,
            description: Verbiage.fomoio_vip_club_description,
            buttonText: Verbiage.go_vip,
            url: '/vip/',
            startDate: defaultDerivedTopSectionPromotionStart,
            banner: cfgToThemeCdnPath('/misc/vip-club.png'),
            enabled: false
        },
        topSection: {
            buttonVariant: 'primary',
            imageStyles: 'transform: scale(0.85);'
        },
        order: { topSection: 5 }
    }
];
